import {
  actions,
  getCollectionComponentByIdAsync,
  addComponentToCollectionComponentAsync,
  removeComponentFromCollectionComponentAsync,
  reOrderComponentsInCollectionComponentAsync,
  getCollectionComponentLookupsAsync,
  setCollectionComponentDynamicZoneAsync,
  editCollectionComponentAsync,
  getCollectionComponentsStandAloneLookupsAsync,
  getCollectionComponentLayoutLookupsAsync,
  getCollectionComponentBodyLookupsAsync,
  getCollectionComponentDatatableAsync,
  createCollectionComponentByTypeIdAsync,
  cloneCollectionComponentAsync,
  getCollectionComponentByIdMultilingualAsync,
  createCollectionComponentByTypeIdMultilingualAsync,
  editCollectionComponentMultilingualAsync,
} from './slices';

export const CollectionComponetsActions = {
  ...actions,
  getCollectionComponentByIdAsync,
  addComponentToCollectionComponentAsync,
  removeComponentFromCollectionComponentAsync,
  reOrderComponentsInCollectionComponentAsync,
  getCollectionComponentLookupsAsync,
  setCollectionComponentDynamicZoneAsync,
  editCollectionComponentAsync,
  getCollectionComponentsStandAloneLookupsAsync,
  getCollectionComponentLayoutLookupsAsync,
  getCollectionComponentBodyLookupsAsync,
  getCollectionComponentDatatableAsync,
  createCollectionComponentByTypeIdAsync,
  cloneCollectionComponentAsync,
  getCollectionComponentByIdMultilingualAsync,
  createCollectionComponentByTypeIdMultilingualAsync,
  editCollectionComponentMultilingualAsync,
};

export * from './thunkHandlers';
